import HotelClassificationBusinessListModelBase from '../_generated/modelBases/hotel-classification-business-list-model-base';

export default class HotelClassificationBusinessListModel extends HotelClassificationBusinessListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
